import React from "react"
import Layout from "src/components/layout"

const Contact = () => {
  return <Layout>this is contact</Layout>
}

export default Contact
